import { useSuspenseQuery } from '@tanstack/react-query';
import { getAvaturnUserId } from '~/api';
import avaturnKey from './avaturnKey';

const useGetAvaturnUserIdQuery = () => {
  return useSuspenseQuery({
    queryKey: avaturnKey.getAvaturnUserId(),
    queryFn: () => getAvaturnUserId(),
    select: ({ data, status }) => {
      return data.id;
    },
  });
};

export default useGetAvaturnUserIdQuery;
